var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16340",
    "data-name": "Group 16340",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2090",
    "data-name": "Rectangle 2090",
    width: 34,
    height: 39,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "compare",
    transform: "translate(3.23 4.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M52.551,28.084H45.49a2.816,2.816,0,0,1-2.824-2.808V5.617A2.816,2.816,0,0,1,45.49,2.808h7.06V0h2.824V30.893H52.551Zm0-21.063H45.49l7.06,8.425Z",
    transform: "translate(-42.666)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M284.393,67.912h-7.06v-2.8h7.06V46.874l-7.06,8.415V42.667h7.06a2.814,2.814,0,0,1,2.824,2.8V65.107A2.814,2.814,0,0,1,284.393,67.912Z",
    transform: "translate(-259.834 -39.843)",
    fill: "#f9b316"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy3);
export default __webpack_public_path__ + "static/media/why3.92006d93da1cadeae765379b3c75d08a.svg";
export { ForwardRef as ReactComponent };